export default __webpack_public_path__ + "static/media/car.425ab357.svg";